import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import styled from "styled-components"
import { SizeProp } from "@fortawesome/fontawesome-svg-core"

interface Props {
  name: any
  type?: "fas" | "far"
  size?: SizeProp
  className?: string
  onClick?: () => void
  disabled?: boolean
}

const Content = styled.i`
  z-index: 0;
  &.event {
    cursor: pointer;
  }

  .circle {
    border: 1px solid #ededed;
    border-radius: 15px;
    padding: 40px 20px;
    margin: 40px 0px 50px;
  }

  //i.circle {
  //  border-radius: 50%;
  //}

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
    cursor: not-allowed;
  }
`

export default function AcIcon(props: Props) {
  const { name, className = "", size = "1x", type = "fas", onClick, disabled = false } = props
  const icons = name.split(" ")
  return (
    <>
      <Content
        className={`${className} ${onClick ? "event" : ""} ${disabled ? "disabled" : ""}`}
        onClick={onClick?.bind(this)}
      >
        <FontAwesomeIcon
          className={className}
          icon={[type, icons[0]]}
          mask={icons[1] || ""}
          size={size}
        />
      </Content>
    </>
  )
}
